import React from 'react';
import { createGlobalStyle, ThemeProvider} from 'styled-components';
import 'sanitize.css';

import Theme from 'src/themes/theme';
import {colors} from 'src/themes/colors';
import { MDXProvider } from '@mdx-js/react';
import MDXComponents from './src/components/MDXComponents/MDXComponents';
import CookieBar from 'src/components/CookieBar';

const GlobalStyles = createGlobalStyle`
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: ${colors.grey100};
    color: ${colors.blue};
    font-family: ${Theme.primaryFont};
    font-size: 16px;
    line-height: 1.5;
  }

  a {
    text-decoration: none;
  }
`

export const wrapRootElement = ({element}) => (
    <ThemeProvider theme={Theme}>
        <GlobalStyles />
        <MDXProvider components={MDXComponents}>
        {element}
        </MDXProvider>
        <CookieBar />
    </ThemeProvider>
);